/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

function FieldGroup({ label, ...props }) {
  return (
    <FormGroup>
        {label && (props.id !== undefined) && !props.required && <ControlLabel htmlFor={props.id}>{label}</ControlLabel>}
        {label && (props.id !== undefined) && props.required && <ControlLabel htmlFor={props.id}>{label} <span className="text-danger-1">*</span></ControlLabel>}
        {label && (props.id === undefined) && !props.required && <ControlLabel>{label}</ControlLabel>}
        {label && (props.id === undefined) && props.required && <ControlLabel>{label} <span className="text-danger-1">*</span></ControlLabel>}
      <FormControl {...props} />
    </FormGroup>
  );
}

export class FormInputs extends Component {
  render() {
    var row = [];
    for (var i = 0; i < this.props.ncols.length; i++) {
      row.push(
        <div key={i} className={this.props.ncols[i]}>
          <FieldGroup {...this.props.proprieties[i]} />
        </div>
      );
    }
    return <div className="row">{row}</div>;
  }
}

export default FormInputs;
